var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplorePlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-784 -5296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(784 5296)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(801 5310.273)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.112 19.612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.278,236.931l-7.2-7.321L236.669,231l7.2,7.321a2.346,2.346,0,0,1-.014,3.293l-.331.331a2.345,2.345,0,0,1-3.293.014l-7.215-7.093-1.389,1.412,7.215,7.093a4.331,4.331,0,0,0,6.082-.026l.331-.331A4.332,4.332,0,0,0,245.278,236.931Z",
    transform: "translate(-231.624 -229.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.789,4.808a13.935,13.935,0,1,0,4.082,9.854A13.843,13.843,0,0,0,23.789,4.808Zm-1.4,18.307a11.955,11.955,0,1,1,0-16.907h0A11.969,11.969,0,0,1,22.389,23.115Z",
    transform: "translate(0 -0.726)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.205 5.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.074,60.614a8.994,8.994,0,0,0,0,17.988.66.66,0,0,0,0-1.32,7.674,7.674,0,1,1,7.674-7.674.66.66,0,0,0,1.32,0A9,9,0,0,0,72.074,60.614Z",
    transform: "translate(-63.08 -60.614)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorePlatform);
export default __webpack_public_path__ + "static/media/explore-platform.536c7573acad196d8579fbd6320b6f65.svg";
export { ForwardRef as ReactComponent };